import React, { Component } from "react";
import { connect } from "react-redux";
import RequestResultPage from "components/request/RequestResultPage";
import LabDecision from "containers/request/Initial/LabDecision";
import PageTitle from "containers/request/Initial/RequestPageTitle";
import InitialInfoBar from "containers/request/Initial/RequestPageInfoBar";
import EcoInfoBar from "containers/request/Initial/EcoInfoBar";
import RequestPageContent from "containers/request/Initial/RequestPageContent";
import DecisionResultPage from "containers/request/Initial/Steps/Laboratory/DecisionResultPage";
import { isInitial, isEco } from "helpers/RequestHelper";
import { canBeAcceptedForTesting } from "helpers/RequestTestsHelper";
import { notifyMessages } from "helpers/NotifyHelper";
import {
  fetchRequest,
  clearRequest,
  makeLabDecision,
  getUsersManualInfo
} from "actions/request";
import { startPreloader, finishPreloader } from "actions/preloader";
import { fetchRequestTests, fetchTestReports, clearTests } from "actions/tests";
import { showNotice } from "actions/notifier";

class RequestPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      labDecision: {
        selected: false,
        accepted: false
      }
    };
  }

  componentDidMount() {
    this.fetchRequestData(this.props.match.params.id);
  }

  fetchRequestData = id => {
    const { startPreloader, fetchRequest } = this.props;

    // start preloading
    startPreloader();

    // fetching request data
    return fetchRequest(id)
      .then(this.fetchTestsAndReports)
      .then(this.fetchUserManualInfo);
  };

  fetchTestsAndReports = res => {
    if (!res.payload.data) return null;

    const id = res.payload.data.data.id;
    this.props.fetchRequestTests(id).then(res => {
      if (res.payload.data.data.length) {
        const testId = res.payload.data.data[0].id;

        // fetching request tests
        this.props.fetchTestReports(testId).then(this.props.finishPreloader);
      }
    });
  };

  fetchUserManualInfo = () => {
    return this.props.getUsersManualInfo(this.props.request.model.id);
  };

  componentDidUpdate(prevProps) {
    const { match, request } = this.props;

    // get new request id
    const newId = match.params.id;

    // if id is different with current, than fetch new request data
    if (newId !== prevProps.match.params.id) {
      return this.fetchRequestData(newId);
    }

    // request wasn't fetched from server before right after submission
    if (request && request.needUpdate === undefined) {
      return this.fetchRequestData(newId);
    }

    // need update request data due to server changes
    if (
      prevProps.request &&
      !prevProps.request.needUpdate &&
      request &&
      request.needUpdate
    ) {
      return this.fetchRequestData(newId);
    }

    if (
      request &&
      prevProps.request &&
      request.isTogglerEnabled !== prevProps.request.isTogglerEnabled &&
      request.isTogglerEnabled === false
    ) {
      this.fetchRequestData(match.params.id);
    }
  }

  componentWillUnmount() {
    this.props.clearRequest();
    this.props.clearTests();
  }

  render() {
    const { request, user, history, tests } = this.props;

    if (request === null || tests === null) {
      return null;
    }

    const { id, type } = request;

    const renderCommonBlocks = () => {
      return (
        <div>
          <PageTitle />
          <InitialInfoBar />
          <EcoInfoBar />
        </div>
      );
    };

    if (request.formSaved) {
      return (
        <div>
          <RequestResultPage
            isUpdate={true}
            isInitial={isInitial(type)}
            isEco={isEco(type)}
            history={history}
          />
        </div>
      );
    }

    if (this.state.labDecision.selected) {
      return (
        <div>
          {renderCommonBlocks()}
          <DecisionResultPage
            id={id}
            isAccepted={this.state.labDecision.accepted}
          />
        </div>
      );
    }

    const testStatus = tests.length ? tests[0].requestteststatusid : null;

    return (
      <div>
        {renderCommonBlocks()}
        <LabDecision
          testStatus={testStatus}
          show={canBeAcceptedForTesting(testStatus) && user.isLab}
          labDecisionHandler={this.handleLabDecision}
        />
        <RequestPageContent role={user.role} />
      </div>
    );
  }

  handleLabDecision = value => {
    this.props.makeLabDecision(value, this.props.request).then(res => {
      if (res.error) {
        this.props.showNotice(notifyMessages.errorLabRequestAction);
        return setTimeout(() => {
          window.location = "/lab/requests";
        }, 1000);
      }

      this.setState({
        labDecision: {
          selected: true,
          accepted: value
        }
      });
    });
  };
}

function mapStateToProps({ request, user, tests }) {
  return { request, user, tests };
}

export default connect(mapStateToProps, {
  fetchRequest,
  clearRequest,
  makeLabDecision,
  startPreloader,
  finishPreloader,
  fetchRequestTests,
  fetchTestReports,
  clearTests,
  getUsersManualInfo,
  showNotice
})(RequestPage);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/RequestPage.js